import { useState, useEffect } from "react";
import { useLanguage } from "./LanguageContext";

export default function Navbar() {
  const { t, lang, setLang } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { label: t.navHome, href: "#home" },
    { label: t.navCountdown, href: "#countdown" },
    { label: t.navGallery, href: "#gallery" },
    { label: t.navRsvp, href: "#rsvp" },
    { label: t.navFaq, href: "#faq" },
    { label: t.navHotels, href: "#hotels" },
    { label: t.navRegistry, href: "#faq" },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`nav-wedding ${scrolled ? "scrolled" : ""}`}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: "0 24px",
      }}
    >
      <div style={{
        maxWidth: "1100px",
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "64px",
      }}>
        <a
          href="#home"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "1.3rem",
            color: "#1e40af",
            textDecoration: "none",
            fontWeight: 600,
          }}
        >
          E & D
        </a>

        {/* Desktop links */}
        <div style={{ display: "flex", gap: "32px", alignItems: "center" }} className="desktop-nav">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="nav-link">
              {link.label}
            </a>
          ))}
          {/* Language toggle */}
          <button
            onClick={() => setLang(lang === "en" ? "es" : "en")}
            style={{
              background: "none",
              border: "1px solid var(--blue-300)",
              borderRadius: "6px",
              padding: "4px 10px",
              cursor: "pointer",
              fontSize: "0.8rem",
              fontWeight: 700,
              color: "var(--blue-700)",
              letterSpacing: "1px",
              transition: "all 0.3s",
            }}
            title={lang === "en" ? "Cambiar a Español" : "Switch to English"}
          >
            {lang === "en" ? "ES" : "EN"}
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="mobile-nav-btn"
          style={{
            display: "none",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "8px",
          }}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1e40af" strokeWidth="2">
            {menuOpen ? (
              <path d="M6 6l12 12M6 18L18 6" />
            ) : (
              <path d="M3 6h18M3 12h18M3 18h18" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu" style={{
          padding: "16px 24px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          background: "rgba(255, 255, 255, 0.98)",
          borderTop: "1px solid rgba(30, 64, 175, 0.1)",
        }}>
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="nav-link"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => { setLang(lang === "en" ? "es" : "en"); setMenuOpen(false); }}
            style={{
              background: "none",
              border: "1px solid var(--blue-300)",
              borderRadius: "6px",
              padding: "6px 12px",
              cursor: "pointer",
              fontSize: "0.85rem",
              fontWeight: 700,
              color: "var(--blue-700)",
              alignSelf: "flex-start",
            }}
          >
            {lang === "en" ? "Español" : "English"}
          </button>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-nav-btn { display: block !important; }
        }
      `}</style>
    </nav>
  );
}
